"use client";
import { createContext } from "react";
import type { EvidenceFilter } from "../data";

export interface EvidenceFilterValue {
  show: EvidenceFilter;
  setShow: (show: EvidenceFilter) => void;
}

// Outside a provider every card shows at full strength.
export const EvidenceFilterContext = createContext<EvidenceFilterValue>({
  show: "all",
  setShow: () => {},
});
